<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="hub/person-military/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { PersonMilitary } from '@/modules/hub/data/person-military/create'
	import { PersonMilitaryService } from '@/modules/hub/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return PersonMilitary;
			},

			service()
			{
				return new PersonMilitaryService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>